export default [
  {
    'name' : '🏆 2018 캡스톤디자인 경진대회 대상',
    'info' : '아두이노 + 자동차 RC카를 결합하여 주차공간을 찾아 자동으로 주차를 진행하는 시스템',
    'disc' : '아두이노 자동주차RC카 조선대학교 캡스톤디자인 대상',
    'date' : '2018.07'
  },
  {
    'name' : '삼성 SW 아카데미 1기 (SSAFY) 입학',
    'info' : '문제해결 능력을 갖춘 경쟁력 있는 차세대 SW인력을 양성하는 프로그램',
    'disc' : '삼성전자 + 고용노동부',
    'date' : '2018.12'
  },
  {
    'name' : '🥇 SW Expert Academy A형 취득',
    'disc' : '알고리즘 실력 향상',
    'date' : '2019.05'
  },
  {
    'name' : '삼성 SW 아카데미 1학기 수료',
    'info' : 'Java + Algorithm + Web Project 진행',
    'disc' : '교육시간 800 시간 수료',
    'date' : '2019.05'
  },
  {
    'name' : '🏆 삼성SW아카데미 AI 챗봇 프로젝트 광주 1등',
    'info' : 'Python + MachineLearning + Crwaling',
    'disc' : '네이버 기사를 파싱해 뉴스와 댓글에 대한 AI분석을 나타냄.',
    'date' : '2019.10'
  }
]
